var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"tenant-keys"}},[_c(_vm.activeComponent,_vm._b({tag:"component",on:{"onSwitchComponent":_vm.onSwitchComponent}},'component',{keysData: _vm.keysData, isEditMode: _vm.isEditMode},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }